module.exports = __webpack_public_path__ + "img/活動辦法.508b5e13.png";